import {
  CustomerQuotaAndCallsSuccess,
  CustomerQuotaAndCallsFail
} from "../constant";
import { toast } from "react-toastify";

export const initialState = {
  CustomerQuotaAndCallsByIdSuccess : null,
  CustomerQuotaAndCallsByIdFail : null
};

let toastConfig = {
  position: toast.POSITION.TOP_RIGHT,
  autoClose: 2500,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case CustomerQuotaAndCallsSuccess:
      return {
        ...state,
        CustomerQuotaAndCallsByIdSuccess: action.payload,
      };
    case CustomerQuotaAndCallsFail:
      return {
        ...state,
        CustomerQuotaAndCallsByIdFail: action.payload.message,
      };
    default:
      return state;
  }
}
